// Story 8.1 (ADO-2010), Tasks 5.2 and 7.2 — the choice screen (Figma "Select Depot",
// desktop 5031:4205, tablet 5238:8070, mobile 5238:46605) and its "Your open carts"
// panel (5031:4579; mobile sheet 5243:9014, tablet tray 5243:9593).
//
// Where a Shopper who has something to choose lands after sign-in (A1.1, A4, A5), and
// where the header "Depots" entry leads (A9.1):
//   - "Shop by depot": the entries that are not Value Centres (the core depots and the
//     Fruit & Veg, WOW, Corrib Retail and LSN ranges), one tile per account (A4.2), the
//     account line shown only where the entry offers several (`namesItsAccount`: a core
//     depot names no account for accounts the Customer merely holds there);
//   - "Select your VC depot": one tile per account of every Value Centre entry (the
//     server's `isValueCentre`), labelled with the account name and number (A4.1);
//   - "Your open carts (n)": every cart (a depot and, Story 8.4 ADO-2013, a Trading Account)
//     holding a DRAFT with a line, and its line count (A11.1), each an accordion (`OpenCartCard`, Figma 5031:4601) that opens on
//     the cart's lines, read on demand, and "Continue shopping" (take it up), "Review
//     order" (take it up and open its Order Review) or "Submit now" (take it up and send it
//     at once through `submitOpenCart`; Story 8.6). A sent order is confirmed here, in the
//     "Order sent" dialog (`OrderSentDialog`), and the open carts are read again; a failed
//     send opens the Order Review, which shows why, with "Try again". While that send runs
//     every choice on the page (tiles and every card's actions) is disabled: another
//     take-up would switch the depot and drop the send's answer. A cart that could not be
//     opened keeps its message here, like its lines, so closing the mobile sheet does not
//     lose it.
//   Story 8.4 (ADO-2013): a Value Centre offers every account the store holds there, and each
//   account has its own cart: its own tile (with its own "In cart" pill and cut-off) and its own
//   open-cart card (Figma 5031:4601), named with the account. A card takes up exactly its own
//   cart, so it asks for no account (D-4). Everything the page keeps per cart (the open card,
//   its lines, a send running, a failed open) is keyed by the depot AND the account.
// Every choice goes through `selectOrderingChoice` (store + remembered hint) and then
// to the account's destination (A10.1), or to the location the Shopper asked for when
// the browsing gate (`RequireOrderingChoice`) sent them here first (the deep link wins,
// after the pick). A failed read is an error with a retry, distinct from an unlinked
// Shopper's "no accounts to order against" (A2.2). A failed open-carts read alone says so
// with a retry, and never presents itself as "no open carts".
//
// Behind everything under the header sits the Figma "soft network background" (5413:81878),
// served from `public/images` like the brand logos and handed to the stylesheet as the
// `--choose-background-image` custom property.
//
// Story 8.5 (ADO-2014), D-20: the cut-off. Each tile and open cart card carries its cart's
// `CutOffPill` (`small`), and the "Next cut-off" line under the heading names the soonest
// with an "N more" list (`NextCutOff`); all of them share one read per cart (Story 8.4: per
// depot and account, so each Value Centre account shows its own).
//
// Cart money, from the prices the server locked on the cart lines. Each cart is
// read from ONE source (`cartAt`), so its cases, lines and value always come from the same
// lines: this visit's line read of the cart, made when its card was opened, so the head
// matches the lines the card shows; else the session cart's basket once it has loaded (and
// its read did not fail); else the open-carts read (the server's counts and its sum of the
// stored line totals). The visit read wins over the basket: it is read on this page, and
// only "Submit now" touches the basket here; a sent cart's read is forgotten, so its depot's
// basket (reset and re-read empty by the send) is its source again. The depot tile's pill,
// the open cart's head and the narrow-viewport summary all read that snapshot; a cart whose
// source has no value shows no money, never a zero, and the summary shows no value when any
// cart's is unknown. No case count is shown (A11.1): the snapshot's cases only decide whether
// a tile's cart holds anything. The session's cart leaves the list once the live basket
// is its source and holds no line. The open cart's PRICE column and Total are
// `OpenCartCard`'s.
//
// Enabler E8-G (ADO-3109):
//   - DA-8 (AC9): every cart is its entry's (the depot, the account and the entry kind), so
//     Fruit & Veg's cart is its own beside Chill's at depot 25: its own tile count, its own
//     open-cart card, its own take-up, review and send. SL1.0 shows the two apart: Fruit & Veg
//     is its own tile after Chill (`engine/get_smanager.php:4602-4615`) with its own environment
//     and cart (`choose.htm:39`, `?env=ChillFruitVeg`). They share one cut-off read, as SL1.0
//     reads one delivery schedule for both (`get_smanager.php:5563-5565,5673-5676`).
//   - Task 2.6: the four Value Centres SL1.0 shows as tiles of their own (`showsAsOwnTile`: 4
//     Aces, Better Deal, Corrib Foods, Collooney; `get_smanager.php:4591,4594-4597`) are listed
//     under "Shop by depot", in the server's order, each account a tile with its account line
//     (a Value Centre still names its account, Story 8.4); "Select your VC depot" lists the
//     other Value Centres. Figma "Select Depot" (5031:4205) has no frame for them, so this
//     follows SL1.0's layout (`engine/templates/choose.htm:35-223`).
//   - DA-10 (AC11): a staff user has no depot-keyed cart. A staff depot tile opens a store
//     account search (`StaffAccountPicker`); the pick becomes the active account and the cart
//     opens for it. A staff tile makes no "Empty cart" claim: its store carts are listed under
//     "Your open carts", each taken up for its own account.
//
// Story 8.15 (ADO-2024), D-9 and D-10 (C-1): what happened to the caller's auto-sent carts, as
// banners after the page's own notices (`AutoSendOutcomeBanners`): "Order auto-sent without HHT
// orders" for a cart that went before the cut-off while HHT orders waited, and "Your <depot> order
// was not sent automatically" for one that did not go. Each is dismissed for everyone on the cart.
//
// Story 8.10 (ADO-2019), DV-36/DV-37: the HHT waiting card sits just above "Shop by depot"
// (it renders nothing unless the workflow applies and an order is waiting), and the bar is
// the `ChooserHeader` shared with the HHT pages. The Customer NAME in the
// Figma heading is not in the ordering contract (`customerCode` only), so the heading shows
// the code alone.

import { type CSSProperties, useEffect, useRef, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router';
import { isSafeReturnTo } from '../../auth/auth0-client';
import { Banner, Button, CutOffPill, Icon, Modal, useHeaderLayout } from '../../design-system';
import type { OrderingEntry, OrderingStaffAccount } from '../../api/ordering-choices.client';
import { cartTargetKey, sameCartTarget, type CartTarget } from '../../api/cart-target';
import { useSessionStore } from '../../auth/useSessionStore';
import { useBasketStore } from '../../basket/useBasketStore';
import { cartValue, totalCases as totalCasesOf } from '../../basket/cartTotals';
import { totalOfCartValues } from '../../basket/cartMoney';
import { formatMoney, type MoneyValue } from '../../shared/money';
import { useDepotCutOff } from '../../basket/useDepotCutOff';
import { useHhtOrdersStore } from '../../hht/useHhtOrdersStore';
import { useHhtWaitingCountStore } from '../../hht/useHhtWaitingCountStore';
import { isCutOffShown } from '../../shared/cutOffDisplay';
import {
  CHOOSE_ROUTE,
  cartName,
  cartTargetOf,
  choiceOptions,
  choiceSections,
  cutOffTargets,
  destinationFor,
  entryForCart,
  openCartFor,
  singleOrderingTarget,
  type ChoiceOption,
  type ChoiceTile,
} from '../../ordering/orderingChoices';
import {
  reloadOrderingChoices,
  selectOrderingChoice,
  selectStaffAccount,
} from '../../ordering/orderingSession';
import { listBasket, type BasketLine } from '../../api/basket.client';
import { useSessionCartTarget } from '../../basket/sessionCart';
import { submitOpenCart, type SubmitOpenCartResult } from '../../basket/submitOpenCart';
import { useOrderSubmissionStore } from '../../basket/useOrderSubmissionStore';
import { useHhtSendGuardStore } from '../../hht/useHhtSendGuardStore';
import { HhtSendGuardDialog } from '../HhtOrders/HhtSendGuardDialog';
import { HhtWaitingCard } from '../HhtOrders/HhtWaitingCard';
import { AutoSendOutcomeBanners } from '../../basket/AutoSendOutcomeBanners';
import { ChooserHeader } from './ChooserHeader';
import { depotAccent, depotIconSrc } from './depotAccent';
import { NextCutOff } from './NextCutOff';
import { OpenCartCard, type OpenCartLines } from './OpenCartCard';
import { OrderSentDialog } from './OrderSentDialog';
import { StaffAccountPicker } from './StaffAccountPicker';
import styles from './ChoosePage.module.css';

/** The choice screen's background image (Figma 5413:81878), a public asset. */
export const CHOOSE_BACKGROUND_URL = '/images/shoplink-soft-network-background.svg';

/** The depot's Order Review (Story 8.11), where an open cart's "Review order" leads, and a
 *  "Submit now" send that failed. */
const ORDER_REVIEW_ROUTE = '/cart';

const SURFACE_STYLE = {
  '--choose-background-image': `url("${CHOOSE_BACKGROUND_URL}")`,
} as CSSProperties;

interface TileProps {
  readonly option: ChoiceOption;
  /** False when the open-carts read failed and this tile's cart is unknown: then a zero
   *  count is not shown as "Empty cart". */
  readonly cartKnown: boolean;
  readonly title: string;
  readonly detail: string | null;
  readonly current: boolean;
  /** The tile's cart value where the page knows it; null otherwise. */
  readonly value: MoneyValue | null;
  /** True while a "Submit now" send runs on the page. */
  readonly disabled: boolean;
  readonly onChoose: (option: ChoiceOption) => void;
}

function DepotTile({
  option,
  cartKnown,
  title,
  detail,
  current,
  value,
  disabled,
  onChoose,
}: TileProps) {
  const money = value === null ? null : formatMoney(value);
  // Story 8.5 (ADO-2014), D-20: the cut-off, from the shared read (Chill and Fruit & Veg cost
  // one request). Story 8.4 (ADO-2013): read for the tile's own account, so each Value Centre
  // account shows its own. It is presentational inside the button and not in its name (a
  // ticking name would re-announce); "Next cut-off" lists it.
  const cutOff = useDepotCutOff({
    depotId: option.entry.depotId,
    customerAccountCode: option.customerAccountCode,
  });
  const cartState =
    option.caseCount > 0
      ? `items in cart${money === null ? '' : `, ${money}`}`
      : cartKnown
        ? 'empty cart'
        : null;
  return (
    <li>
      <button
        type="button"
        className={styles.tile}
        data-accent={depotAccent(option.entry)}
        aria-current={current ? 'true' : undefined}
        disabled={disabled}
        aria-label={[title, detail, cartState].filter(Boolean).join(', ')}
        onClick={() => onChoose(option)}
      >
        <span className={styles.tileStroke} aria-hidden />
        <span className={styles.tileTop} aria-hidden>
          <span className={styles.iconTile}>
            <img src={depotIconSrc(depotAccent(option.entry))} width={16} height={16} alt="" />
          </span>
          <span className={styles.arrow}>
            <Icon name="arrowRight" size={14} />
          </span>
        </span>
        <span className={styles.tileTitle}>{title}</span>
        {detail !== null && <span className={styles.tileDetail}>{detail}</span>}
        {isCutOffShown(cutOff.status, cutOff.countdown) && (
          <span className={styles.tileCutOff}>
            <CutOffPill {...cutOff} />
          </span>
        )}
        <span className={styles.tileSpacer} />
        <span className={styles.tileFoot}>
          {option.caseCount > 0 ? (
            <span className={styles.cartPill}>
              {money === null ? 'In cart' : `In cart · ${money}`}
            </span>
          ) : (
            cartKnown && <span className={styles.emptyCart}>Empty cart</span>
          )}
        </span>
      </button>
    </li>
  );
}

/** A cart as the page shows it: cases, lines and value from one source. */
interface CartSnapshot {
  readonly caseCount: number;
  readonly lineCount: number;
  /** `null` when that source has no value for it (never a false zero). */
  readonly value: MoneyValue | null;
}

/** An open cart in the list (its depot and account), at its snapshot. */
interface ListedCart extends CartSnapshot, CartTarget {}

interface OpenCartsListProps {
  readonly carts: readonly ListedCart[];
  readonly entries: readonly OrderingEntry[];
  /** Per cart key (`cartTargetKey`): which cards are open. */
  readonly expanded: ReadonlySet<string>;
  /** Per cart key: each card's line read. */
  readonly lines: Readonly<Record<string, OpenCartLines>>;
  readonly cutOffPlacement: 'head' | 'meta';
  readonly onToggle: (cart: CartTarget) => void;
  readonly onRetry: (cart: CartTarget) => void;
  readonly onContinueShopping: (entry: OrderingEntry, customerAccountCode: string | null) => void;
  readonly onReviewOrder: (entry: OrderingEntry, customerAccountCode: string | null) => void;
  /** The key of the cart whose "Submit now" send is running, or null. */
  readonly sendingCartKey: string | null;
  /** The keys of the carts whose last "Submit now" could not open them. */
  readonly submitFailedCarts: ReadonlySet<string>;
  readonly onSubmitNow: (entry: OrderingEntry, customerAccountCode: string | null) => void;
}

function OpenCartsList({
  carts,
  entries,
  expanded,
  lines,
  cutOffPlacement,
  onToggle,
  onRetry,
  onContinueShopping,
  onReviewOrder,
  sendingCartKey,
  submitFailedCarts,
  onSubmitNow,
}: OpenCartsListProps) {
  return (
    <ul className={styles.cartList}>
      {carts.map((cart) => {
        const entry = entryForCart(entries, cart);
        if (entry === null) return null;
        const key = cartTargetKey(cart);
        return (
          <OpenCartCard
            key={key}
            cart={cart}
            entry={entry}
            expanded={expanded.has(key)}
            lines={lines[key]}
            value={cart.value}
            cutOffPlacement={cutOffPlacement}
            onToggle={() => onToggle(cart)}
            onRetry={() => onRetry(cart)}
            onContinueShopping={onContinueShopping}
            onReviewOrder={onReviewOrder}
            sending={sendingCartKey === key}
            locked={sendingCartKey !== null}
            submitFailed={submitFailedCarts.has(key)}
            onSubmitNow={onSubmitNow}
          />
        );
      })}
    </ul>
  );
}

/** The location the browsing gate carried here, when it is a safe in-app path. */
function requestedLocation(state: unknown): string | null {
  const returnTo = (state as { returnTo?: unknown } | null)?.returnTo;
  if (!isSafeReturnTo(returnTo)) return null;
  return returnTo === CHOOSE_ROUTE || returnTo.startsWith(`${CHOOSE_ROUTE}?`) ? null : returnTo;
}

/** The account type of a staff user's open cart being taken up, and whether its store sees the
 *  margin: an open cart names neither and no read finds one by account code, so they are the
 *  session's own pick's when that is this account, else `DEFAULT` and hidden (Enabler E8-G,
 *  DA-10; Story 11.10, ADO-1961, D-3; the search pick carries the store's real values). */
function heldStaffAccount(
  customerAccountCode: string,
): Pick<OrderingStaffAccount, 'tradingAccountType' | 'marginShown'> {
  const held = useSessionStore.getState().activeTradingAccount;
  return held?.customerAccountCode === customerAccountCode
    ? { tradingAccountType: held.tradingAccountType, marginShown: held.marginShown }
    : { tradingAccountType: 'DEFAULT', marginShown: false };
}

export function ChoosePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const returnTo = requestedLocation(location.state);
  const layout = useHeaderLayout();
  const mounted = useRef(true);
  const status = useSessionStore((s) => s.orderingStatus);
  const choices = useSessionStore((s) => s.orderingChoices);
  const activeEntryKey = useSessionStore((s) => s.activeEntryKey);
  const activeTradingAccount = useSessionStore((s) => s.activeTradingAccount);
  // Story 8.4 (ADO-2013): the session's cart, the depot AND the account.
  const activeCart = useSessionCartTarget();
  const basketHydrated = useBasketStore((s) => s.hydrated);
  const basketFailed = useBasketStore((s) => s.error);
  const liveLines = useBasketStore((s) => s.lines);
  const [cartsOpen, setCartsOpen] = useState(false);
  const [retrying, setRetrying] = useState(false);
  // The open-cart accordions: which are open, and each cart's line read, kept for the
  // visit (here rather than in the cards, so closing the mobile sheet loses neither). Every
  // per-cart record here is keyed by `cartTargetKey` (the depot and the account).
  const [expandedCarts, setExpandedCarts] = useState<ReadonlySet<string>>(() => new Set());
  const [cartLines, setCartLines] = useState<Readonly<Record<string, OpenCartLines>>>({});
  const cartLinesRequested = useRef(new Set<string>());
  // The cart whose "Submit now" send is running: every choice on the page waits for it.
  const [sendingCartKey, setSendingCartKey] = useState<string | null>(null);
  const sendRunning = sendingCartKey !== null;
  // The carts whose last "Submit now" could not open them, kept here so the message
  // survives the mobile sheet closing (which unmounts the cards).
  const [submitFailedCarts, setSubmitFailedCarts] = useState<ReadonlySet<string>>(() => new Set());
  // The name of the cart "Submit now" last sent, shown in the "Order sent" dialog until the
  // Shopper dismisses it.
  const [sentCartName, setSentCartName] = useState<string | null>(null);
  const loadHhtOrders = useHhtOrdersStore((s) => s.load);
  const markSubmitFailed = (cartKey: string, failed: boolean) =>
    setSubmitFailedCarts((current) => {
      const next = new Set(current);
      if (failed) next.add(cartKey);
      else next.delete(cartKey);
      return next;
    });

  // Refresh the snapshot on arrival, so a Shopper returning here through "Depots" sees
  // the open-cart counts as they are now. The page keeps what it has while it reads.
  useEffect(() => {
    mounted.current = true;
    if (useSessionStore.getState().orderingChoices !== null) void reloadOrderingChoices();
    return () => {
      mounted.current = false;
    };
  }, []);

  // Story 8.10 (ADO-2019), DV-7/DV-39: read the HHT details for the waiting card's summary
  // line, only when the cheap count says the workflow applies and something waits (so staff
  // and everyone it does not apply to never pay for the classified read), and again whenever
  // the waiting count changes, so the summary matches the title. The card's title and button,
  // and the header badge, read the count, which the app re-reads on route changes
  // (`HhtWaitingCountRefresher`).
  const hhtWaitingCount = useHhtWaitingCountStore((s) => (s.applies ? s.waitingCount : 0));
  useEffect(() => {
    if (hhtWaitingCount > 0) void loadHhtOrders();
  }, [hhtWaitingCount, loadHhtOrders]);

  const goTo = () =>
    navigate(returnTo ?? destinationFor(useSessionStore.getState().activeTradingAccount));

  // Enabler E8-G (ADO-3109), DA-10 (AC11): the staff entry whose store account search is open.
  const [staffPickEntry, setStaffPickEntry] = useState<OrderingEntry | null>(null);
  const staff = choices?.scope === 'DEPOT_IDS';
  // Take up the cart of `entry` for `customerAccountCode`: a store user's entry offers the
  // account; a staff user names the store account the cart is keyed by (DA-10).
  const select = (entry: OrderingEntry, customerAccountCode: string | null): boolean =>
    staff && customerAccountCode !== null
      ? selectStaffAccount(entry.key, {
          depotCode: entry.depotCode,
          customerAccountCode,
          accountName: '',
          ...heldStaffAccount(customerAccountCode),
        })
      : selectOrderingChoice(entry.key, customerAccountCode);
  const choose = (option: ChoiceOption) => {
    if (sendRunning) return;
    // A staff depot tile names no account: the staff user picks one first.
    if (staff && option.customerAccountCode === null) {
      setStaffPickEntry(option.entry);
      return;
    }
    if (selectOrderingChoice(option.entryKey, option.customerAccountCode)) goTo();
  };
  const pickStaffAccount = (account: OrderingStaffAccount) => {
    const entry = staffPickEntry;
    setStaffPickEntry(null);
    if (entry !== null && !sendRunning && selectStaffAccount(entry.key, account)) goTo();
  };
  const takeUp = (entry: OrderingEntry, customerAccountCode: string | null) => {
    if (sendRunning) return;
    setCartsOpen(false);
    if (select(entry, customerAccountCode)) goTo();
  };
  // The Shopper asked for the review, so it wins over the location the gate carried.
  const reviewOrder = (entry: OrderingEntry, customerAccountCode: string | null) => {
    if (sendRunning) return;
    setCartsOpen(false);
    if (select(entry, customerAccountCode)) navigate(ORDER_REVIEW_ROUTE);
  };
  // Story 8.10 (ADO-2019), Q2: a manual send of a cart at an HHT depot, or of the Default VC
  // cart (DV-73), while HHT orders wait asks first (`useHhtSendGuardStore`). The tray or sheet
  // the cart is listed in steps aside for the question and comes back for "Send anyway" (to show
  // "Submitting…") or a cancel.
  const guardedSubmitNow = (entry: OrderingEntry, customerAccountCode: string | null) => {
    if (sendRunning) return;
    const reopen = cartsOpen;
    void useHhtSendGuardStore
      .getState()
      .guard(
        cartTargetOf(entry, customerAccountCode),
        () => {
          if (reopen) setCartsOpen(true);
          void submitNow(entry, customerAccountCode);
        },
        { onDismiss: () => reopen && setCartsOpen(true) },
      )
      .then((asked) => {
        if (asked && reopen) setCartsOpen(false);
      });
  };
  // The take-up comes first: it switches the session depot, which clears the send store, so
  // a send started before it would lose its answer. The page does not close the mobile
  // sheet while the send runs, so its "Submitting…" is seen; the open failure is held here,
  // so it is still shown if the Shopper closes the sheet and opens it again.
  // A settled send that was sent closes the sheet, shows the "Order sent" dialog and reads the
  // open carts again (the send emptied the cart, AC8, so it leaves the list); one that failed opens
  // the Order Review, which shows why. On any other outcome the page unlocks and stays here
  // (`'open-failed'` is the card's message, `'superseded'` has none). A rejected sequence
  // counts as `'open-failed'`, so the lock never outlives the press.
  const submitNow = async (entry: OrderingEntry, customerAccountCode: string | null) => {
    if (sendRunning) return;
    const cart = cartTargetOf(entry, customerAccountCode);
    const cartKey = cartTargetKey(cart);
    markSubmitFailed(cartKey, false);
    if (!select(entry, customerAccountCode)) {
      markSubmitFailed(cartKey, true);
      return;
    }
    setSendingCartKey(cartKey);
    // Enabler E8-G (ADO-3109), DA-1: the revision the open-carts list showed for the cart, which
    // the send carries, as "Submit now" has no cart view of its own.
    const listed = openCartFor(useSessionStore.getState().orderingChoices?.openCarts ?? [], cart);
    let result: SubmitOpenCartResult = 'open-failed';
    try {
      result = await submitOpenCart(
        cart,
        listed?.revision === undefined ? {} : { seenRevision: listed.revision },
      );
    } catch {
      result = 'open-failed';
    }
    if (!mounted.current) return;
    // `'settled'` means the store holds this send's outcome for the depot.
    const sent = result === 'settled' && useOrderSubmissionStore.getState().phase === 'sent';
    if (result !== 'settled' || sent) setSendingCartKey(null);
    if (sent) {
      setCartsOpen(false);
      forgetCartLines(cartKey);
      // Story 8.4 (ADO-2013): "VC Dublin · Tobacco", so the Shopper sees which account's order
      // went.
      setSentCartName(
        staff && customerAccountCode !== null
          ? `${entry.label} · ${customerAccountCode}`
          : cartName(
              entry,
              entry.accounts.find((account) => account.customerAccountCode === customerAccountCode),
            ),
      );
      void reloadOrderingChoices();
    } else if (result === 'settled') {
      setCartsOpen(false);
      navigate(ORDER_REVIEW_ROUTE);
    } else if (result === 'open-failed') {
      markSubmitFailed(cartKey, true);
    }
  };
  const closeOrderSent = () => setSentCartName(null);

  // Story 8.4 (ADO-2013): the card's own cart, its depot and account, is read.
  const loadCartLines = (cart: CartTarget) => {
    const cartKey = cartTargetKey(cart);
    cartLinesRequested.current.add(cartKey);
    setCartLines((current) => ({ ...current, [cartKey]: { status: 'loading' } }));
    listBasket(cart).then(
      (basket) => {
        if (mounted.current) {
          setCartLines((current) => ({
            ...current,
            [cartKey]: { status: 'loaded', lines: basket.lines },
          }));
        }
      },
      () => {
        if (mounted.current) {
          setCartLines((current) => ({ ...current, [cartKey]: { status: 'error' } }));
        }
      },
    );
  };
  // A sent cart is emptied (Enabler E8-G, ADO-3109, AC8): its lines are read afresh when next opened.
  const forgetCartLines = (cartKey: string) => {
    cartLinesRequested.current.delete(cartKey);
    setCartLines((current) =>
      Object.fromEntries(Object.entries(current).filter(([key]) => key !== cartKey)),
    );
    setExpandedCarts((current) => {
      const next = new Set(current);
      next.delete(cartKey);
      return next;
    });
  };
  const toggleCart = (cart: CartTarget) => {
    const cartKey = cartTargetKey(cart);
    const opening = !expandedCarts.has(cartKey);
    setExpandedCarts((current) => {
      const next = new Set(current);
      if (opening) next.add(cartKey);
      else next.delete(cartKey);
      return next;
    });
    // The first opening reads the lines; a reopening reuses them, and a failed read is
    // retried from its own "Try again".
    if (opening && !cartLinesRequested.current.has(cartKey)) loadCartLines(cart);
  };

  const retry = async () => {
    setRetrying(true);
    const hadChoice = useSessionStore.getState().activeEntryKey !== null;
    const applied = await reloadOrderingChoices();
    // The Shopper may have left while the read was in flight, or a newer read may have
    // superseded this one: then this retry no longer decides where they go.
    if (!mounted.current) return;
    setRetrying(false);
    // A retry that resolves the choice on its own (one entry, or a remembered one)
    // continues straight in, as the sign-in would have. A Shopper who already had a
    // choice (back here through "Depots") stays to pick: this retry did not choose.
    if (applied && !hadChoice && useSessionStore.getState().activeEntryKey !== null) goTo();
  };

  // Story 8.10 (ADO-2019), DV-37: the bar shared with the HHT pages (logo, "HHT Orders",
  // account chip). The logo is the way into browsing; a store user who still has to choose
  // stays here (the browsing routes would send them back anyway, AC4/AC5).
  const header = <ChooserHeader />;

  const heading = (
    <h1 className={styles.heading}>
      {choices?.customerCode ? `Customer ${choices.customerCode}` : 'Choose where to order'}
    </h1>
  );

  if (choices === null) {
    return (
      <div className={styles.page}>
        {header}
        <div className={styles.surface} style={SURFACE_STYLE}>
          <main className={styles.main}>
            {heading}
            {status === 'error' ? (
              <div className={styles.notice}>
                <Banner type="error">
                  We couldn&rsquo;t load where you can order. Please try again.
                </Banner>
                <Button variant="secondary" onClick={() => void retry()} disabled={retrying}>
                  Try again
                </Button>
              </div>
            ) : (
              <p role="status" className={styles.status}>
                Loading where you can order…
              </p>
            )}
          </main>
        </div>
      </div>
    );
  }

  // A Customer with a single ordering target has nothing to choose here, so the screen sends
  // them straight on: to the page the gate sent them here from (a shared /products link opened
  // signed out, Epic 7 3 amigos 2026-11-02), else their catalogue. The header offers no way here
  // for them either. Only
  // once their choice is active, so this never meets the browsing gate's redirect back here,
  // and never while a "Submit now" send runs or its "Order sent" dialog is open (a send's
  // re-read can leave a single target), which would drop the confirmation.
  if (
    activeEntryKey !== null &&
    singleOrderingTarget(choices) !== null &&
    !sendRunning &&
    sentCartName === null
  ) {
    return <Navigate to={returnTo ?? destinationFor(activeTradingAccount)} replace />;
  }

  // The session cart's live basket is a source once it has loaded without error.
  const liveAtActive = basketHydrated && !basketFailed;
  const isActiveCart = (cart: CartTarget) => sameCartTarget(cart, activeCart);
  // The cart's lines as this visit read them, once that read has loaded.
  const readHere = (cart: CartTarget): readonly BasketLine[] | null => {
    const read = cartLines[cartTargetKey(cart)];
    return read?.status === 'loaded' ? read.lines : null;
  };
  // One snapshot per cart (depot and account), so a tile, a cart's head, its expanded lines
  // and the summary always show cases, lines and value read from the same lines: this visit's
  // line read of that cart, else the session cart's basket once it has loaded without error,
  // else the open-carts read. `null` when none of them knows the cart.
  const cartAt = (cart: CartTarget): CartSnapshot | null => {
    const lines = readHere(cart) ?? (isActiveCart(cart) && liveAtActive ? liveLines : null);
    if (lines !== null) {
      return { caseCount: totalCasesOf(lines), lineCount: lines.length, value: cartValue(lines) };
    }
    const listed = openCartFor(choices.openCarts, cart);
    return listed === null
      ? null
      : { caseCount: listed.caseCount, lineCount: listed.lineCount, value: listed.value ?? null };
  };
  const optionCart = (option: ChoiceOption): CartTarget =>
    cartTargetOf(option.entry, option.customerAccountCode);
  const options = choiceOptions(choices).map((option) => {
    const cart = cartAt(optionCart(option));
    return cart === null ? option : { ...option, caseCount: cart.caseCount };
  });
  // A tile's cart is known from the open-carts read, or from the live basket of the
  // session cart once it has loaded without error. A staff depot tile stands for no one cart
  // (DA-10: each store account there has its own), so it claims none.
  const cartKnown = (option: ChoiceOption) =>
    !(staff && option.customerAccountCode === null) &&
    (choices.openCartsAvailable || (liveAtActive && isActiveCart(optionCart(option))));
  const sections = choiceSections(options);
  // A staff depot tile is current for the depot whatever store account was picked there.
  const isCurrent = (option: ChoiceOption) =>
    option.entryKey === activeEntryKey &&
    (staff || option.customerAccountCode === (activeTradingAccount?.customerAccountCode ?? null));
  // The listed carts at their snapshot. The session cart, once the live basket is its
  // source and holds no line, is no longer open (the server lists only carts holding one);
  // a cart opened here keeps the lines it read, and one read empty says so.
  const openCarts = choices.openCarts.flatMap((listed): ListedCart[] => {
    if (entryForCart(choices.entries, listed) === null) return [];
    if (
      isActiveCart(listed) &&
      liveAtActive &&
      readHere(listed) === null &&
      liveLines.length === 0
    ) {
      return [];
    }
    const cart = cartAt(listed) ?? {
      caseCount: listed.caseCount,
      lineCount: listed.lineCount,
      value: listed.value ?? null,
    };
    return [
      {
        ...cart,
        depotId: listed.depotId,
        customerAccountCode: listed.customerAccountCode,
        entryKind: listed.entryKind,
      },
    ];
  });
  const openCartsFailed = !choices.openCartsAvailable;
  const cartsTitle = `Your open carts (${openCarts.length})`;
  const totalValue = totalOfCartValues(openCarts.map((cart) => cart.value));
  const wide = layout === 'desktop';
  // Story 8.5 (ADO-2014), D-20, and Story 8.4 (ADO-2013): what the tiles show, one per cart
  // (depot and account) in the server's order, each named by `cutOffTargets`.
  const cutOffDepots = cutOffTargets(choices);

  const renderTile = ({ option, title, detail }: ChoiceTile) => (
    <DepotTile
      key={option.id}
      option={option}
      cartKnown={cartKnown(option)}
      title={title}
      detail={detail}
      current={isCurrent(option)}
      value={cartAt(optionCart(option))?.value ?? null}
      disabled={sendRunning}
      onChoose={choose}
    />
  );

  const cartsList = (
    <OpenCartsList
      carts={openCarts}
      entries={choices.entries}
      expanded={expandedCarts}
      lines={cartLines}
      cutOffPlacement={wide ? 'head' : 'meta'}
      onToggle={toggleCart}
      onRetry={loadCartLines}
      onContinueShopping={takeUp}
      onReviewOrder={reviewOrder}
      sendingCartKey={sendingCartKey}
      submitFailedCarts={submitFailedCarts}
      onSubmitNow={(entry, customerAccountCode) => guardedSubmitNow(entry, customerAccountCode)}
    />
  );

  return (
    <div className={styles.page}>
      {header}
      <div className={styles.surface} style={SURFACE_STYLE}>
        <main className={styles.main}>
          {heading}
          {options.length > 0 && (
            <NextCutOff
              depots={cutOffDepots}
              layout={layout === 'mobile' ? 'stacked' : 'columns'}
            />
          )}
          {status === 'error' && (
            <div className={styles.notice}>
              <Banner type="error">
                We couldn&rsquo;t refresh your carts. What you see may be out of date.
              </Banner>
              <Button variant="secondary" onClick={() => void retry()} disabled={retrying}>
                Try again
              </Button>
            </div>
          )}
          {openCartsFailed && status !== 'error' && options.length > 0 && (
            <div className={styles.notice}>
              <Banner type="warning">Your open carts could not be loaded.</Banner>
              <Button variant="secondary" onClick={() => void retry()} disabled={retrying}>
                Try again
              </Button>
            </div>
          )}
          <AutoSendOutcomeBanners className={styles.autoSendOutcomes} />
          {options.length === 0 ? (
            <>
              <HhtWaitingCard className={styles.hhtCard} />
              <Banner type="info">
                There are no accounts to order against yet. Please contact your BWG representative.
              </Banner>
            </>
          ) : (
            <>
              {!wide && openCarts.length > 0 && (
                <button
                  type="button"
                  className={styles.cartsSummary}
                  aria-haspopup="dialog"
                  onClick={() => setCartsOpen(true)}
                >
                  <Icon name="cart" size={18} />
                  <span className={styles.cartsSummaryText}>
                    <strong>
                      {openCarts.length === 1 ? '1 open cart' : `${openCarts.length} open carts`}
                    </strong>
                    {totalValue !== null && ` · ${formatMoney(totalValue)}`}
                  </span>
                  <Icon name="caretRight" size={18} />
                </button>
              )}
              {/* Story 8.10 (ADO-2019), DV-36: the HHT card just above "Shop by depot":
                  after "Next cut-off" on desktop, after the open carts bar on tablet and
                  mobile. It renders nothing unless an order waits. */}
              <HhtWaitingCard className={styles.hhtCard} />
              <div className={styles.columns}>
                <div className={styles.sections}>
                  {sections.byDepot.length > 0 && (
                    <section className={styles.section} aria-labelledby="choose-by-depot">
                      <h2 id="choose-by-depot" className={styles.sectionTitle}>
                        Shop by depot
                      </h2>
                      <ul className={styles.grid}>{sections.byDepot.map(renderTile)}</ul>
                    </section>
                  )}
                  {sections.valueCentres.length > 0 && (
                    <section className={styles.section} aria-labelledby="choose-vc-depot">
                      <h2 id="choose-vc-depot" className={styles.sectionTitle}>
                        Select your VC depot
                      </h2>
                      <ul className={styles.grid}>{sections.valueCentres.map(renderTile)}</ul>
                    </section>
                  )}
                </div>
                {wide && openCarts.length > 0 && (
                  <section className={styles.carts} aria-labelledby="choose-open-carts">
                    <h2 id="choose-open-carts" className={styles.sectionTitle}>
                      <Icon name="cart" size={18} />
                      {cartsTitle}
                    </h2>
                    {cartsList}
                  </section>
                )}
              </div>
            </>
          )}
        </main>
      </div>
      {!wide && (
        // Figma: a bottom sheet on mobile (5243:9014), a side tray on tablet (5243:9593).
        <Modal
          open={cartsOpen}
          onClose={() => setCartsOpen(false)}
          title={cartsTitle}
          placement={layout === 'mobile' ? 'bottom' : 'end'}
        >
          {cartsList}
        </Modal>
      )}
      <Modal
        open={staffPickEntry !== null}
        onClose={() => setStaffPickEntry(null)}
        title={
          staffPickEntry === null ? 'Choose a store' : `Choose a store · ${staffPickEntry.label}`
        }
        description="Search for the store account you are ordering for."
        placement={layout === 'mobile' ? 'bottom' : 'center'}
      >
        {staffPickEntry !== null && (
          <StaffAccountPicker entry={staffPickEntry} onPick={pickStaffAccount} />
        )}
      </Modal>
      <OrderSentDialog
        cartName={sentCartName}
        placement={layout === 'mobile' ? 'bottom' : 'center'}
        onClose={closeOrderSent}
      />
      <HhtSendGuardDialog />
    </div>
  );
}

export default ChoosePage;
